<template>
  <div id="app">
    <Cartographie/>
  </div>
</template>

<script>
import Cartographie from './components/Cartographie'

export default {
  name: 'App',
  components: {
    Cartographie
  }
}
</script>

<style>
body {
  color: #12204c;
  padding: 0;
  margin: 0 !important;
  font-family: Arial, Helvetica, sans-serif;
}
</style>
